import React from 'react'
import { PaginaNode } from '@gql/graphql'
import { PlaceholderReact } from '@components/molecules'
import { AcquistiOnlineLayout, Page } from 'components/organisms'
import styles from './AcquistiOnlineDetailTemplate.module.sass'

interface Props {
  pagina?: PaginaNode
  mainContent?: any
}

const AcquistiOnlineDetailTemplate = (props: Props) => {
  const { pagina = undefined, mainContent = undefined } = props

  return (
    <Page pagina={pagina} className={`${styles.root}`}>
      <AcquistiOnlineLayout pagina={pagina}>
        <div className={styles.pbWrap}>
          <PlaceholderReact
            contentTypeId={pagina.model}
            objectId={pagina.pk}
            pkey={'main'}
            serverSideContent={mainContent}
          />
        </div>
      </AcquistiOnlineLayout>
    </Page>
  )
}

export default AcquistiOnlineDetailTemplate
